module.exports = __webpack_public_path__ + "static/img/chat-tips@2x.fd2896d8.png";